import { OrgInfoFormValues, OrgInfoFormViolation } from 'types/orgInfoTypes';
import { stringIsEmpty } from 'utils/stringUtils';
// import { stringIsEmpty, stringIsEmail } from 'utils/stringUtils';

export const validateOrgInfoFormValues = (
  values: OrgInfoFormValues
): OrgInfoFormViolation[] => {
  const violations: OrgInfoFormViolation[] = [];

  if (stringIsEmpty(values.name)) {
    violations.push({
      name: 'NameMissed',
    });
  }

  if (values.location === null) {
    violations.push({
      name: 'LocationMissed',
    });
  }

  return violations;
};

export const createOrgInfoFormViolationLense = (
  violation: OrgInfoFormViolation
) => ({
  isNameViolation() {
    switch (violation.name) {
      case 'NameMissed':
        return true;
      default:
        return false;
    }
  },
  isLocationViolation() {
    switch (violation.name) {
      case 'LocationMissed':
        return true;
      default:
        return false;
    }
  },
  isStaffCountViolation() {
    switch (violation.name) {
      default:
        return false;
    }
  },
});
